var utils = require('../../utils')

export default {
  name: 'will-must-edit',
  async created () {
    var hiduke = new Date()
    var month = hiduke.getMonth() + 1
    if (month !== 5 && month !== 6 && month !== 11 && month !== 12) {
      this.$router.push({path: '/will_must_sent'})
    }
    let param = {
      'user_id': window.localStorage.getItem('user_id')
    }
    await this.$store.dispatch('GET_WILL_MUST_DRAFT', {data: param, callback: this.set})
  },
  data () {
    return {
      will: null,
      must: null,
      reflect: null,
      evaluation: null,

      willDraft: null,
      mustDraft: null,
      reflectDraft: null,
      evaluationDraft: null,

      willSuccessFlag: false,
      mustSuccessFlag: false,
      reflectSuccessFlag: false,

      willDraftLength: 0,
      mustDraftLength: 0,
      reflectDraftLength: 0,

      willDraftLimit: 256,
      mustDraftLimit: 256,
      reflectDraftLimit: 240,

      hadSavedFlag: false,

      willMustMonth: null,
      willMustYear: null,
      willMustDay: null,

      callbackFlag: false
    }
  },
  watch: {
    mustDraft () {
      this.limitCharacter('mustDraft')
    },
    willDraft () {
      this.limitCharacter('willDraft')
    },
    reflectDraft () {
      this.limitCharacter('reflectDraft')
    }
  },
  computed: {
    willMustDate () {
      return this.$store.getters.willMustDate
    },
    willData () {
      return this.$store.getters.willData
    },
    mustData () {
      return this.$store.getters.mustData
    },
    reflectData () {
      return this.$store.getters.reflectData
    },
    evaluationData () {
      return this.$store.getters.evaluationData
    },
    willDraftData () {
      return this.$store.getters.willDraftData
    },
    mustDraftData () {
      return this.$store.getters.mustDraftData
    },
    reflectDraftData () {
      return this.$store.getters.reflectDraftData
    },
    evaluationDraftData () {
      return this.$store.getters.evaluationDraftData
    },
    canSaveFlag () {
      if (this.willMustMonth === 12) {
        // must, will, 評価, 振り返りの全て入力されている場合
        if (this.willDraft !== '' &&
        this.mustDraft !== '' &&
        this.reflectDraft !== '' &&
        this.evaluationDraft !== null) {
          // must, will, 評価, 振り返りの入力が現在提出されているものと全て一致する場合
          if (this.willData === this.willDraft &&
            this.mustData === this.mustDraft &&
            this.reflectData === this.reflectDraft &&
            this.evaluationData === this.evaluationDraft) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      } else if (this.willMustMonth === 6) {
        // 評価, 振り返りの全て入力されている場合
        if (this.reflectDraft !== '' &&
           this.evaluationDraft !== null) {
          // 評価, 振り返りの入力が現在提出されているものと全て一致する場合
          if (this.reflectData === this.reflectDraft &&
             this.evaluationData === this.evaluationDraft) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      }
    },
    saveWillDraftFlag () {
      if (this.willDraft === '') {
        return true
      } else {
        if (this.willDraftData === this.willDraft) {
          return true
        } else {
          return false
        }
      }
    },
    saveMustDraftFlag () {
      if (this.mustDraft === '') {
        return true
      } else {
        if (this.mustDraftData === this.mustDraft) {
          return true
        } else {
          return false
        }
      }
    },
    saveReflectDraftFlag () {
      if (this.reflectDraft === '') {
        return true
      } else {
        if (this.reflectDraftData === this.reflectDraft) {
          return true
        } else {
          return false
        }
      }
    },
    saveEvaluationDraftFlag () {
      if (this.evaluationDraft === '') {
        return true
      } else {
        if (this.evaluationDraftData === this.evaluationDraft) {
          return true
        } else {
          return false
        }
      }
    },
    saveWillFlag () {
      return this.willData === this.willDraftData
    },
    saveMustFlag () {
      return this.mustData === this.mustDraftData
    },
    saveReflectFlag () {
      return this.reflectData === this.reflectDraftData
    },
    saveEvaluationFlag () {
      return this.evaluationData === this.evaluationDraftData
    }
  },
  methods: {
    goTop: function () {
      this.$router.push({path: '/'})
    },
    goSent: function () {
      this.$router.push({path: '/will_must_sent'})
    },
    temporarilyWillSave: function () {
      let param = {
        'user_id': window.localStorage.getItem('user_id'),
        'will_content': this.willDraft
      }
      this.$store.dispatch('SAVE_WILL_MUST_DRAFT', {data: param, callback: this.showSuccess})
    },
    temporarilyMustSave: function () {
      let param = {
        'user_id': window.localStorage.getItem('user_id'),
        'must_content': this.mustDraft
      }
      this.$store.dispatch('SAVE_WILL_MUST_DRAFT', {data: param, callback: this.showSuccess})
    },
    temporarilyReflectSave: function () {
      let param = {
        'user_id': window.localStorage.getItem('user_id'),
        'reflect_content': this.reflectDraft,
        'evaluation': this.evaluationDraft
      }
      this.$store.dispatch('SAVE_WILL_MUST_DRAFT', {data: param, callback: this.showSuccess})
    },
    save: function () {
      let param = {
        'user_id': window.localStorage.getItem('user_id'),
        'will_content': this.willDraft,
        'must_content': this.mustDraft,
        'reflect_content': this.reflectDraft,
        'evaluation': this.evaluationDraft,
        'will_must_date': this.willMustDate
      }
      this.$store.dispatch('SAVE_WILL_MUST', {data: param, callback: this.goSent})
    },
    set: function () {
      this.willMustYear = new Date(this.willMustDate).getFullYear()
      this.willMustMonth = new Date(this.willMustDate).getMonth() + 1
      this.willMustDay = new Date(this.willMustDate).getDate()

      this.will = this.willData
      this.must = this.mustData
      this.reflect = this.reflectData
      this.evaluation = this.evaluationData

      this.willDraft = this.$store.getters.willDraftData
      this.mustDraft = this.$store.getters.mustDraftData
      this.reflectDraft = this.$store.getters.reflectDraftData
      this.evaluationDraft = this.$store.getters.evaluationDraftData

      if (this.willMustMonth === 12) {
        this.hadSavedFlag = this.willData !== null &&
                            this.mustData !== null &&
                            this.reflectData !== null &&
                            this.evaluationData !== null
      } else if (this.willMustMonth === 6) {
        this.hadSavedFlag = this.reflectData !== null &&
                            this.evaluationData !== null
      }

      this.limitCharacter('willDraft', this.willDraftLimit)
      this.limitCharacter('mustDraft', this.mustDraftLimit)
      this.limitCharacter('reflectDraft', this.reflectDraftLimit)
      this.callbackFlag = true
    },
    showSuccess: function (target) {
      var self = this
      if (target === 'will_content') {
        this.willSuccessFlag = true
        this.saveWillDraftFlag = false
        window.setTimeout(function () {
          self.willSuccessFlag = false
        }, 3000)
      } else if (target === 'must_content') {
        this.mustSuccessFlag = true
        this.saveMustDraftFlag = false
        window.setTimeout(function () {
          self.mustSuccessFlag = false
        }, 3000)
      } else if (target === 'reflect_content and evaluation') {
        this.reflectSuccessFlag = true
        this.saveReflectDraftFlag = false
        window.setTimeout(function () {
          self.reflectSuccessFlag = false
        }, 3000)
      }
    },
    getCharacterLength: function (str) {
      let result = 0
      for (let i = 0; i < str.length; i++) {
        let charCode = str.charCodeAt(i)
        if ((charCode >= 0x00 && charCode < 0x81) ||
          (charCode === 0xf8f0) ||
          (charCode >= 0xff61 && charCode < 0xffa0) ||
          (charCode >= 0xf8f1 && charCode < 0xf8f4)) {
          result += 1
        } else {
          result += 2
        }
      }
      return result
    },
    limitCharacter: function (target) {
      let data = ''
      const col = 16
      const limit = this[target + 'Limit']

      if (this[target]) {
        data = utils.removeEmoji(this[target])
      }
      let result = ''
      let totalWork = 0 // 文字数カウント
      let work = 0 // 一列の文字数カウント
      let lastcol = 0 // 最終行の１文字目の位置

      lastcol = target === 'reflectDraft' ? 225 : 241

      for (let i = 0; i < data.length; i++) {
        let char = data.substr(i, 1)

        if (totalWork >= limit) {
          break
        } else if (totalWork >= lastcol && (char === '\n' || char === '\r' || char === '\r\n')) {
          break
        } else {
          if (work === 0) {
            if (char === '\n' || char === '\r' || char === '\r\n') {
              totalWork += col
            } else {
              totalWork += 1
              work += 1
              result += char
            }
          } else if (work === col) {
            if (char === '\n' || char === '\r' || char === '\r\n') {
              result += char
              work = 0
            } else {
              totalWork += 1
              result += char
              work = 1
            }
          } else {
            if (char === '\n' || char === '\r' || char === '\r\n') {
              totalWork += (col - work)
              result += char
              work = 0
            } else {
              totalWork += 1
              result += char
              work += 1
            }
          }
        }
      }

      this[target] = result
      this[target + 'Length'] = totalWork
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/will-must-edit.js